import TextField from "@mui/material/TextField";
import { alpha, styled } from "@mui/material/styles";
import axios from "axios";
import React, { useState } from "react";
import LoadingSpinner from "../customComponents/LoadingSpinner";

export default function AdminPanelLogin({ loginUser }) {
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    function login() {
        setIsLoading(true);
        if (password === "") {
            return;
        }

        axios
            .post("apm/login", { password })
            .then((response) => {
                setIsLoading(false);
                loginUser(response.data);
            })
            .catch((error) => {
                setIsLoading(false);
            });
    }

    const RedditTextField = styled((props) => (
        <TextField InputProps={{ disableUnderline: true }} {...props} />
    ))(({ theme }) => ({
        "& .MuiFilledInput-root": {
            border: "1px solid #e2e2e1",
            overflow: "hidden",
            borderRadius: 4,
            color: "white",
            backgroundColor: "#fcfcfb",
            // theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
            // transition: theme.transitions.create([
            //     "border-color",
            //     "background-color",
            //     "box-shadow",
            // ]),
            "&:hover": {
                backgroundColor: "#2b2b2b",
            },
            "&.Mui-focused": {
                backgroundColor: "#2b2b2b",
                boxShadow: `${alpha("#fff", 0.25)} 0 0 0 2px`,
                // borderColor: theme.palette.primary.main,
            },
        },
    }));

    return (
        <div className="container">
            <h4 className="my-5 text-center">
                Please Login to enter in Admin Panel!
            </h4>
            <div className="d-flex flex-column">
                <RedditTextField
                    label="Reddit"
                    defaultValue="react-reddit"
                    id="reddit-input"
                    variant="filled"
                />
                <input
                    className="col-4 mb-3 mx-auto p-1"
                    type="password"
                    defaultValue={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button
                    className="col-1 mx-auto d-flex align-items-center justify-content-center"
                    disabled={isLoading}
                    onClick={() => login()}
                >
                    {isLoading && <LoadingSpinner height={20} width={20} />}
                    <span>Login</span>
                </button>
            </div>
        </div>
    );
}
